import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Pipeline from './Pipeline';
import PartnerManagement from '../components/PartnerManagement';

const CRM = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get('tab') || 'pipeline';
  const [activeTab, setActiveTab] = useState(
    ['pipeline', 'partners'].includes(initialTab) ? initialTab : 'pipeline'
  );

  // Sync tab with URL
  useEffect(() => {
    setSearchParams({ tab: activeTab }, { replace: true });
  }, [activeTab, setSearchParams]);

  const tabs = [
    { id: 'pipeline', label: 'Pipeline', icon: '💰' },
    { id: 'partners', label: 'Partners', icon: '🤝' },
  ];

  return (
    <div className="h-screen flex flex-col bg-black">
      {/* Sub-nav bar */}
      <div className="px-6 pt-5 pb-0 border-b border-zinc-800 bg-black">
        <div className="flex items-center justify-between mb-4">
          <h1 className="text-2xl font-bold text-white">CRM</h1>
        </div>
        <div className="flex gap-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`pb-3 font-medium transition-colors border-b-2 flex items-center gap-2 ${
                activeTab === tab.id
                  ? 'text-nextide-turquoise border-nextide-turquoise'
                  : 'text-zinc-400 hover:text-white border-transparent'
              }`}
            >
              <span className="text-sm">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto min-w-0">
        {activeTab === 'pipeline' && <Pipeline />}
        {activeTab === 'partners' && <PartnerManagement />}
      </div>
    </div>
  );
};

export default CRM;
